import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchMe } from '@/api/authApi';
import type { MeResponse } from './types';
import { fetchMeRequested, fetchMeSucceeded, fetchMeFailed } from './authSlice';

function* handleFetchMe() {
  try {
    const res: MeResponse = yield call(fetchMe);
    yield put(fetchMeSucceeded({ authenticated: res.authenticated, user: res.user ?? null }));
  } catch {
    yield put(fetchMeFailed());
  }
}

export function* authSaga() {
  yield takeLatest(fetchMeRequested.type, handleFetchMe);
}
